import { useQuery } from '@tanstack/react-query';
import { getUserPermissions } from '@lib/auth/role.utils';
import { useCurrentAccount } from '@lib/auth/auth.hooks';
import { authKeys } from '@lib/auth/auth.utils';

/**
 * Hook to get user permissions with TanStack Query caching
 * This replaces the WeakMap caching with React Query's more robust caching
 */
export function useUserPermissionsQuery() {
  const account = useCurrentAccount();

  return useQuery({
    queryKey: authKeys.permissions(account?.homeAccountId),
    queryFn: () => getUserPermissions(account),
    enabled: !!account,
    staleTime: 5 * 60 * 1000, // Consider permissions fresh for 5 minutes
    gcTime: 30 * 60 * 1000, // Keep in cache for 30 minutes
  });
}